module.exports = __webpack_public_path__ + "img/wx.b687b7f2.png";